import './style.modules.scss'

import { Content } from '@ampcore/adel-react'
import React from 'react'
import xss from 'xss'

import { Image, ImageProps } from '../Image/Image'

export type Milestone = {
  year: string
  text: string
  images?: ImageProps[] | ImageProps
}

export type MilestonesProps = {
  milestones: Milestone[]
  testId?: string
}

export const Milestones = (props: MilestonesProps) => {
  const { milestones, testId } = props

  return (
    <section
      className="u-paddingVert48 u-sizeConstrained"
      data-testid={testId}
      aria-label="Company milestones timeline"
    >
      <div className="Milestones u-sm-paddingHoriz20 u-md-paddingHoriz48 u-padding80">
        {milestones.map((milestone, index) => {
          const milestoneKey = `milestone-${milestone.year}-${index}`
          const side = index % 2 === 0 ? 'left' : 'right'
          const images = (
            [milestone.images].flat().filter(Boolean) as ImageProps[]
          )
            .filter(image => image.src)
            .map((image, idx) => ({ ...image, key: `image-${idx}` }))
          const hasMultipleImages = images.length > 1
          const milestoneContent = (
            <div className="Milestone-content u-padding20 u-bgColorStone u-posRelative u-borderRadius24">
              <span className="u-hiddenVisually">{`${milestone.year}, `}</span>
              {images.map((image, imageIndex) => {
                let imageModifier = 'Milestone-image--single'
                if (hasMultipleImages) {
                  imageModifier =
                    imageIndex === 0
                      ? 'Milestone-image--left'
                      : 'Milestone-image--right'
                }

                return (
                  <div
                    className={`Milestone-image ${imageModifier}`}
                    key={image.key}
                  >
                    <Image
                      src={image.src}
                      alt={image.alt}
                      testId={
                        testId
                          ? `${testId}-image-${index}-${imageIndex}`
                          : undefined
                      }
                    />
                  </div>
                )
              })}
              <Content
                open={true}
                className="Milestone-text"
                data-testid={testId ? `${testId}-text-${index}` : undefined}
                dangerouslySetInnerHTML={{ __html: xss(milestone.text) }}
              />
            </div>
          )

          return (
            <div
              className={`Milestone Milestone--${side} u-posRelative`}
              key={milestoneKey}
              data-testid={testId ? `${testId}-milestone-${index}` : undefined}
            >
              <div className="Milestone-column Milestone-column--left">
                {side === 'left' ? milestoneContent : null}
              </div>
              <span
                className="Milestone-year u-textColorWhite u-flex u-flexJustifyCenter u-flexAlignItemsCenter u-bgColorBrand"
                data-testid={testId ? `${testId}-year-${index}` : undefined}
                aria-hidden="true"
              >
                {milestone.year}
              </span>
              <div className="Milestone-column Milestone-column--right">
                {side === 'right' ? milestoneContent : null}
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
